import type { AppConfigState } from "@/src/config/appConfigTypes"

import { createContext } from "react"

// ----------------------------------------------------------------------

export const AppConfigContext = createContext<AppConfigState | undefined>(undefined)
